// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1pW4G","vLegacy":"SelectSecondary_vLegacy__1DAbL","error":"SelectSecondary_error__VMqfR","disabled":"SelectSecondary_disabled__BRpQm"};